import { configure } from 'mobx';
import { createRoot } from 'react-dom/client';
import { Router } from 'react-router-dom';
import { BugsnagEventLogger, EventLogger } from '../models/Logging';
import { polyfillAsync } from '../models/UiUtils';
import { SonnerToast } from '../web/components/SonnerToast';
import { TooltipProvider } from '../web/components/Tooltip';
import { AppHashHistory } from '../web/constants/hash-history';
import { AidaApp } from './containers/AidaApp';
import { AidaRouter } from './containers/AidaRouter';
import { DraggableWindowContextProvider } from './contexts/draggableWindowContext';
import { SearchProvider } from './contexts/search';
import { ViewportProvider } from './hooks/useViewport';
import './styles/global-styles.less';

const bugsnagEventLogger = new BugsnagEventLogger(import.meta.env.MODE);
const ErrorBoundary = bugsnagEventLogger.getErrorBoundary();
EventLogger.addLogger(bugsnagEventLogger);

document.addEventListener('DOMContentLoaded', async () => {
	await polyfillAsync();
	configure({ enforceActions: 'never' });

	const root = createRoot(document.getElementById('react-root'));
	root.render(
		<ErrorBoundary>
			<Router history={AppHashHistory}>
				<AidaApp>
					<TooltipProvider>
						<SearchProvider>
							<ViewportProvider>
								<DraggableWindowContextProvider>
									<AidaRouter history={AppHashHistory} />
								</DraggableWindowContextProvider>
							</ViewportProvider>
						</SearchProvider>
					</TooltipProvider>
					{/* Hide sonner toast b/c looks like mrry popup overrides toasts in coffee https://github.com/Real-Magic/Levitate-FrontEnd/blob/274c4b99bbed8b8b3f188d1d68a6ea5bc1ecb411/packages/main/app/aida/containers/MainContainer/index.tsx#L43 */}
					<SonnerToast style={{ display: 'none' }} />
				</AidaApp>
			</Router>
		</ErrorBoundary>
	);
});
